export default {
  signUp: '/winter12', //hide /signup temporarily to prevent random signups
  signUpWithRole: '/winter12/:role', //hide /signup temporarily to prevent random signups
  signUpV2: '/winter12v2',
  signUpV2Agent: '/sign-up',
  signUpV2AgentAlternative: '/signup',
};
